/**
 * Pure helper functions extracted from auction_timer_controller.js
 */

export function parseTimeRemaining(diffMs) {
  const total = Math.max(0, diffMs)
  const seconds = Math.floor((total / 1000) % 60)
  const minutes = Math.floor((total / (1000 * 60)) % 60)
  const hours = Math.floor((total / (1000 * 60 * 60)) % 24)
  const days = Math.floor(total / (1000 * 60 * 60 * 24))
  return { days, hours, minutes, seconds }
}

export function formatTimeRemaining(days, hours, minutes, seconds) {
  if (days > 0) {
    return `${days}d ${hours}h ${minutes}m`
  } else if (hours > 0) {
    return `${hours}h ${minutes}m ${seconds}s`
  } else if (minutes > 0) {
    return `${minutes}m ${seconds}s`
  } else {
    return `${seconds}s`
  }
}

export function getUrgencyLevel(totalSeconds, warningThreshold, urgentThreshold) {
  if (totalSeconds <= urgentThreshold) {
    return 'urgent'
  } else if (totalSeconds <= warningThreshold) {
    return 'warning'
  } else {
    return 'normal'
  }
}

export function padZero(num) {
  return num.toString().padStart(2, '0')
}
